/* eslint-disable */
import {
  getData,
  addData,
  removeData
} from '@/requests/tenantsInfo'

import { handleErrorMessage } from '@/core/helpers/messageHelper'

import { Message } from 'element-ui'
import Api from '@/repository/index'
import globalMixin from '@/mixin/global'
const { getUtcFromDate } = globalMixin.methods
const state = {
  tenantsInfoData: [],
  isLoading: true,
  filter: {
    driverIds: [],
    offset: 0,
    limit: 100,
    isWorking: true,
    search: null
  },
  drivers_count: 0,
  currentRegionParkID: null,
  tenantNations: {
    blr: 'Белоруссия',
    kaz: 'Казахстан',
    rus: 'Россия',
    ukr: 'Украина'
  }
}

const getters = {
  getCandidates: (state) => {
    return state.tenantsInfoData.filter(cur => cur.category === 'candidate')
  },
  getTrial: (state) => {
    return state.tenantsInfoData.filter(cur => cur.category === 'trial')
  },
  getDrivers: (state) => {
    return state.tenantsInfoData.filter(cur => cur.category === 'driver')
  },
  getDriversByFilter: (state, getters) => {
    return state.tenantsInfoData
    // if (!state.filter.driverIds.length) return state.tenantsInfoData
    // console.log(state.filter.driverIds)
    // return state.tenantsInfoData.filter(val => state.filter.driverIds.some(v => val.id === v))
  },
  getSheduleDrivers: (state) => {
    return state.tenantsInfoData.filter(cur => cur.category === 'driver' || cur.category === 'trial')
  },
  GET_BY_ID: state => id => state.tenantsInfoData.find(cur => cur.driverId === id),
  getById: state => prop_id => state.tenantsInfoData.filter(item => item.driverId === prop_id),
  GREAT_NAME_DRIVER_BY_ID: (state) => prop_id => {
    if (!prop_id) return 'Водитель не выбран'
    return state.tenantsInfoData.filter(item => Number(item.driverId) === Number(prop_id)).map(driver => `${driver.firstName} ${driver.secondName || ''} ${driver.lastName}`)[0]
  }
}

const mutations = {
  SET_TENANT: (state, tenantsInfoData) => {
    state.tenantsInfoData = tenantsInfoData
  },
  SET_DRIVERS_COUNT: (state, count) => {
    state.drivers_count = count
  },
  REMOVE_TENANT: (state, id) => {
    state.tenantsInfoData = state.tenantsInfoData.filter(cur => cur.id !== id)
  },
  ADD_TENANT: (state, tenantInfoData) => {
    state.tenantsInfoData.push(tenantInfoData)
  },
  SET_DRIVER_IDS: (state, ids) => {
    state.filter.driverIds = ids
  },

  UPDATE_FILTERS: (state, data) => {
    if (data?.search) {
      state.filter = {
        search: data.search,
        offset: 0,
        limit: state?.filter?.limit,
        isWorking: true
      }
      return false
    }
    state.filter = { ...state.filter, ...data }
  },
  TOOGLE_LOADING (state, value) {
    state.isLoading = value
  },
  UPDATE_DRIVER_BALANCE_BY_ID (state, value) {
    const index = state.tenantsInfoData.findIndex(x => x.driverId === value.params.driver_id)
    if (index === -1) return console.log('4to to ne tak => UPDATE_DRIVER_BALANCE_BY_ID', value)
    state.tenantsInfoData.splice(index, 1, { ...state.tenantsInfoData[index], driverBalance: value.data.at(-1)?.totalBalance ?? 0 })
  },
  UPDATE_DRIVER_BALANCE_DEPOSIT_BY_ID (state, value) {
    const index = state.tenantsInfoData.findIndex(x => x.driverId === value.params.driverId)
    if (index === -1) return console.log('4to to ne tak => UPDATE_DRIVER_BALANCE_DEPOSIT_BY_ID', value)
    state.tenantsInfoData.splice(index, 1, { ...state.tenantsInfoData[index], driverDeposit: value.data.at(-1)?.totalBalance ?? 0 })
  },
  UPDATE_DRIVER_BY_ID (state, item) {
    state.tenantsInfoData.filter(driver => driver.id === item.id)
      .map(mapElement => {
        mapElement.detached_park = item.detached_park
        mapElement.count_detached_changes_left = item.count_detached_changes_left
        mapElement.count_detached_changes = item.count_detached_changes
        return {
          ...mapElement
        }
      })
    // const index = state.tenantsInfoData.findIndex(e => e.id === item.id)
    // state.tenantsInfoData.splice(index, 1, item)
  },
  SET_CURRENT_REGION_PARK_ID: (state, value) => {
    state.currentRegionParkID = value
  }
  // CHANGE_TENANT: (state, tenantInfoData) => {
  //   state.tenantsInfoData.forEach(cur => {
  //     if (cur.id === tenantInfoData.id) {
  //       cur.category = tenantInfoData.category
  //       cur.first_name = tenantInfoData.first_name
  //       cur.last_name = tenantInfoData.last_name
  //       cur.middle_name = tenantInfoData.middle_name
  //       cur.schedule = tenantInfoData.schedule
  //     }
  //   })
  // }
  // CHANGE_TENANT: (state, driverDto) => {
  //   state.tenantsInfoData = [
  //     state.tenantsInfoData.filter(t => t.id !== driverDto.id),
  //   ]
  // }
}

const actions = {
  setCurrentRegionParkID ({ commit }, region_park_id) {
    commit('SET_CURRENT_REGION_PARK_ID', region_park_id)
  },
  fetchTenantsInfo ({ commit, state }) {
    commit('TOOGLE_LOADING', true)
    return getData({ region_park: state.currentRegionParkID, isWorking: true })
      .then(tenantsInfoData => {
        commit('SET_TENANT', tenantsInfoData)

        commit('TOOGLE_LOADING', false)
        return tenantsInfoData
      })
      .catch((error) => {
        return error
      })
  },
  async fetchTenantsInfoV1 ({ commit, state }) {
    try {
      commit('TOOGLE_LOADING', true)
      const response = await Api.parkManager.drivers.getDrivers({ regionParkId: state.currentRegionParkID, ...state.filter, category: 'driver' })
      commit('SET_TENANT', response.drivers)
      commit('SET_DRIVERS_COUNT', response?.total ?? 0)
      commit('TOOGLE_LOADING', false)
    } catch (err) {
      commit('TOOGLE_LOADING', false)
      return Promise.reject(err)
    }
  },
  async fetchTenantsInfoV1All ({ commit, state }) {
    try {
      commit('TOOGLE_LOADING', true)
      const response = await Api.parkManager.drivers.getDrivers({ offset: 0, limit: 991000, isWorking: true })
      commit('SET_TENANT', response.drivers)
      commit('SET_DRIVERS_COUNT', response?.total ?? 0)
      commit('TOOGLE_LOADING', false)
    } catch (err) {
      commit('TOOGLE_LOADING', false)
      return Promise.reject(err)
    }
  },
  async getReportDriver ({ commit, state }, data) {
    try {
      const response = await Api.reports.getReportDriver(data)
      return response
    } catch (err) {
      return Promise.reject(err)
    }
  },
  async changeDriverRikStatus ({ commit, state }, data) {
    try {
      commit('TOOGLE_LOADING', true)
      await Api.parkManager.drivers.changeDriverRikStatus(data)
      commit('TOOGLE_LOADING', false)
    } catch (err) {
      commit('TOOGLE_LOADING', false)
      return Promise.reject(err)
    }
  },
  async fetchTenantsShortInfo ({ commit, state }) {
    try {
      commit('TOOGLE_LOADING', true)
      const response = await Api.parkManager.drivers.getDrivers({ regionParkId: state.currentRegionParkID, isWorking: true })
      commit('SET_TENANT', response)
      commit('TOOGLE_LOADING', false)
    } catch (err) {
      return Promise.reject(err)
    } finally {
      commit('TOOGLE_LOADING', false)
    }
  },
  async getDriverBalance ({ commit, state }, params) {
    try {
      const { start_date: startDate, end_date: endDate, driver_id: driverId } = params
      const response = await Api.tenants.balance.getDriverBalanceHistory({ startDate: getUtcFromDate(startDate), endDate: getUtcFromDate(endDate), driverId })
      if (response?.length >= 1) {
        commit('UPDATE_DRIVER_BALANCE_BY_ID', { data: response, params })
      }
      return response.sort((a, b) => {
        return new Date(b.date) - new Date(a.date)
      })
    } catch (error) {
      console.error(error)
    }
  },

  async resetDriverPasswordById ({ commit }, driverId) {
    try {
      commit('TOOGLE_LOADING', true)
      await Api.tenants.index.resetDriverPasswordById(driverId)
    } catch (err) {
      handleErrorMessage(err, 'Не удалось сбросить телеграм бота')
    } finally {
      commit('TOOGLE_LOADING', false)
    }
  },

  async putDriverBalance ({ commit, state }, data) {
    try {
      const { comment, changed_balance: changedBalance, driver_id: driverId } = data
      const response = await Api.tenants.balance.updateDriverBalance({ comment, changedBalance: String(changedBalance), driverId: String(driverId) })
      return response
    } catch (error) {
      console.error(error)
    }
  },
  async dropDriverBalances ({ commit, dispatch }, data) {
    try {
      const response = await Api.tenants.balance.dropDriverBalances({ email: 'zalupaKonia@gmail.com' })
      await dispatch('fetchTenantsInfoV1')
      return response
    } catch (error) {
      console.error(error)
    }
  },
  async putDriverDeposit ({ commit, state }, data) {
    try {
      const { comment, changed_balance: changedBalance, driver_id: driverId } = data
      const response = await Api.tenants.deposit.updateDriverDeposit({ 'changedDriverDeposit.comment': comment, 'changedDriverDeposit.changedBalance': String(changedBalance), 'changedDriverDeposit.driverId': String(driverId) })
      return response
    } catch (error) {
      Message({
        message: 'Что-то пошло не так',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
  },
  async getDriverDeposit ({ commit, state }, params) {
    const { start_date: startDate, end_date: endDate, driverId } = params
    const response = await Api.tenants.deposit.getDriverDeposit({ startDate: getUtcFromDate(startDate), endDate: getUtcFromDate(endDate), driverId })
    if (response?.length >= 1) {
      commit('UPDATE_DRIVER_BALANCE_DEPOSIT_BY_ID', { data: response, params })
    }

    return response.sort((a, b) => {
      return new Date(b.date) - new Date(a.date)
    })
  },
  async getTotalDriverDeposit ({ commit, state }, params) {
    const response = await Api.monthly.getTotalDriverDeposit({ regiaonParkId: state?.currentRegionParkID })
    return response
  },
  addTenant ({ commit }, data) {
    return new Promise((resolve, reject) => {
      addData(data).then(res => {
        commit('ADD_TENANT', res)
        Message({
          message: 'Водитель был добавлен',
          type: 'success',
          duration: 5 * 1000
        })
        resolve(res)
      }).catch(error => {
        Message({
          message: 'Ошибка',
          type: 'error',
          duration: 5 * 1000
        })
        reject(error)
      })
    })
  },
  async editDriver ({
    commit,
    dispatch
  }, editDriverDto) {
    try {
      await Api.parkManager.drivers.updateDriver({
        driver: editDriverDto
      })
      await dispatch('fetchTenantsInfoV1')
      Message({
        message: 'Данные о водителе были изменены',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (e) {
      Message({
        message: 'Что-то пошло не так',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(e)
    }
  },
  setFilterDriverIds ({ commit }, ids) {
    commit('SET_DRIVER_IDS', ids)
  },
  removeTenant ({ commit }, id) {
    return new Promise((resolve, reject) => {
      removeData(id).then(res => {
        commit('REMOVE_TENANT', id)
        Message({
          message: 'Кандидат был удален',
          type: 'success',
          duration: 5 * 1000
        })
        resolve(res)
      }).catch(error => {
        Message({
          message: 'Ошибка',
          type: 'error',
          duration: 5 * 1000
        })
        reject(error)
      })
    })
  },
  async generateTenantsFromYandexData () {
    try {
      const response = await Api.parkManager.drivers.saveDriversFromAggregator()
      Message({
        message: 'Арендаторы успешно получены!',
        type: 'success',
        duration: 5 * 1000
      })
      return await response
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async uploadPhotosDriver (_, { driverId, data }) {
    try {
      const response = await Api.parkManager.drivers.uploadPhotosDriver(driverId, data)

      return response
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async deletePhotosDriver (_, { driverId, data }) {
    try {
      const response = await Api.parkManager.drivers.deletePhotosDriver(driverId, data)

      return response
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async getDriverById ({ commit }, id) {
    try {
      const response = await Api.parkManager.drivers.getDriverById({ driverId: id })
      return response
    } catch (err) {
      return Promise.reject(err)
    }
  },
  setFilters ({ commit }, filters) {
    commit('SET_FILTERS', filters)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
